import {
  Component, EventEmitter, HostListener, Input, OnInit,
  Output,
} from '@angular/core';
import { PropertySearchResult } from 'src/app/asset/models/property-search-result.model';
import { PropertySearchService } from 'src/app/core/services/http/Property/property-search.service';
@Component({
  selector: 'property-search',
  templateUrl: './property-search.component.html',
  styleUrls: ['./property-search.component.scss']
})
export class PropertySearchComponent implements OnInit {
  @Input() set isAssetViewClosed (value : boolean){
    if(value){
      this.clearSearch();
      this.unselectProperty();
    } 
  }
  @Output() propertySelected = new EventEmitter<PropertySearchResult>();
  constructor(private propertySearchService: PropertySearchService) { }
  public propertyAddressFragment: string;
  private searchTimeout: any;
  public loadingProperties: boolean = false;
  public showNoPropertyFoundMessage : boolean = false;
  public properties: PropertySearchResult[] = [];
  public selectedProperty: PropertySearchResult = <PropertySearchResult>{};
  public clickedInside: boolean;
  ngOnInit(): void { }
  @HostListener('click')
  clicked() {
    this.clickedInside = true;
  }
  @HostListener('document:click')
  clickedOut() {
    if (!this.clickedInside) {
      if (this.selectedProperty == null) {
        this.clearSearch();
      }
    }
    this.clickedInside = false;
  }
  clearSearch() {
    this.propertyAddressFragment = '';
    this.properties = null;
  }
  onPaste(event: ClipboardEvent) {
    this.propertyAddressFragmentChanged();
  }
  propertyAddressFragmentChanged() {
    this.showNoPropertyFoundMessage = false;
    clearTimeout(this.searchTimeout);
    this.properties = [];
    var $this = this;
    this.searchTimeout = setTimeout(function () {
      $this.propertySearch();
    }, 1000);
  }

  propertySearch() {
    if (this.propertyAddressFragment?.length >= 3) {
      this.loadingProperties = true;
    this.propertySearchService
      .searchProperties(this.propertyAddressFragment)
      .subscribe({
        next: (res) => {
          this.properties = res;
          this.loadingProperties = false;
          this.showNoPropertyFoundMessage  = this.properties == null  || this.properties?.length == 0 ;
        },
        error: () => {
          this.loadingProperties = false;
          this.showNoPropertyFoundMessage = true;
        },
      });
    }
  }


  selectProperty(property: PropertySearchResult) {
    this.selectedProperty = property;
    this.propertySelected.emit(property);
    this.propertyAddressFragment = null;
    this.properties = null;
  }
  unselectProperty() {
    this.selectedProperty = null;
    this.propertySelected.emit(null);
  }

}


